<template>
  <div
    class="rank_division_picker d-flex-column justify-start align-start"
    :key="type"
  >
    <div
      class="d-flex-column justify-start align-start rank_picker_area"
      :class="selectedRank.class"
    >
      <div class="d-flex-row justify-start gap-18">
        <img
          :src="selectedRank.image"
          :alt="selectedRank.title + ' - Selected game rank image'"
          class="selected_rank_image"
        />

        <div class="d-flex-column align-start gap-0">
          <h4 class="font-family-1 h5 f-w-600">{{ title }}</h4>
          <p class="rank-title regular-xl font-family-2">
            {{ selectedRank.title }}
          </p>
        </div>
      </div>

      <div class="rank_picker_container">
        <rank-picker
          v-for="gameRank in soulFighterRanks"
          :rank-image="gameRank.icon"
          :rank-title="gameRank.title"
          :rank="gameRank"
          :select-rank="selectRank"
          :is-selected="isRankSelected(gameRank.id)"
        />
      </div>
      <value-setter v-if="getDetails[type] === 8" />
    </div>

    <div class="d-flex-row" style="padding: 0 18px 18px 18px">
      <drop-down
        v-if="showServer"
        :label="$t('missed.server')"
        placeholder="Select Server"
        item-key="server"
        :drop-items="keyedServers"
        :select-drop-item="selectItem"
        :selected-item="getSelectedServer?.value"
      />
    </div>
  </div>
</template>

<script>
import RankPicker from "../../commonpickers/RankPicker.vue";
import DivisionPicker from "../../commonpickers/DivisionPicker.vue";
import ValueSetter from "../../commonpickers/ValueSetter.vue";
import DropDown from "../../../custom/DropDown.vue";

export default {
  data() {
    return {};
  },

  props: {
    type: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    itemKey: {
      type: String,
      default: "",
    },
    prevRank: {
      default: {},
    },
    showServer: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RankPicker,
    DivisionPicker,
    ValueSetter,
    DropDown,
  },

  methods: {
    selectRank(rank) {
      const details = this.getDetails;

      this.setDetails({
        ...details,
        [this.type]: rank.id,
        soulFighterRankTitle: rank.title,
      });
    },

    isRankSelected(rank) {
      return this.getDetails[this.type] === rank;
    },

    selectItem(key, value) {
      if (key === "server") {
        this.setServer(value);
        return;
      }
      this.setPackExtraOptions({
        [key]: parseInt(value),
      });
    },
  },

  computed: {
    soulFighterRanks() {
      if (this.gameStore.getGamePack.slug !== this.$route.params.gamePackSlug) {
        return [];
      }
      const ranks = this.gameStore.getGamePack?.prices;
      if (!ranks) {
        return [];
      }
      return ranks;
    },
    selectedRank() {
      if (this.getDetails[this.type]) {
        const rank = this.gameStore.getGamePack?.prices?.find(
          (rank) => rank.id === this.getDetails[this.type]
        );
        return {
          image: rank?.icon,
          title: rank?.title,
          class: `${this.currentGameSlug}-${rank?.title?.toLowerCase()}`,
        };
      }
      return {
        image: this.blankImage,
        title: "",
        class: "",
      };
    },
    keyedServers() {
      const servers = this.getGame?.servers || [];
      if (!servers) {
        return [];
      }
      return servers.reduce((acc, value) => {
        return { ...acc, [value.id]: value.title };
      }, {});
    },
  },
  setup() {
    const gameStore = useGameStore();
    const { getGame } = gameStore;
    const { currentGameSlug } = useGameComposable();
    const {
      getDetails,
      getPackExtraOptions,
      getSelectedServer,
      setDetails,
      setServer,
      setPackExtraOptions,
    } = useCheckoutStore();
    const blankImage =
      "data:image/png;base64,R0lGODlhFAAUAIAAAP///wAAACH5BAEAAAAALAAAAAAUABQAAAIRhI+py+0Po5y02ouz3rz7rxUAOw==";
    return {
      getGame,
      gameStore,
      getDetails,
      getPackExtraOptions,
      getSelectedServer,
      setDetails,
      setServer,
      setPackExtraOptions,
      blankImage,
      currentGameSlug,
    };
  },
};
</script>
